import { createRouter } from "vue-router";
import routerConfig from "./router";
import Cookie from "@/utils/cache.js";
import globalStore from "@/store/global.js";
import colorFasTrimStore from "@/views/main/colorTrim/index.js";
import adjustment from "@/views/main/adjustment/oneAdjustment/index.js";
import sAdjustment from "@/views/main/adjustment/oneAdjustment/sIndex.js";
import dAdjustment from "@/views/main/adjustment/oneAdjustment/dIndex.js";
import blendcolorFasTrimStore from "@/views/main/blendColorTrim/index.js";
import blendcolorFormTrimStore from "@/views/main/blendColorTrim/form.js";
import colorFormTrimStore from "@/views/main/colorTrim/form.js";
import colorMatch from "@/views/main/colorMatch/index.js";
import smallSampleColorMatch from "@/views/main/indent/smallSampleList/colorMatch/index.js";
import DsmallSampleColorMatch from "@/views/main/indent/DuplicateSampleList/colorMatch/index.js";
// import filamentBath from "@/views/main/production/exportScheme/filamentBath/index.js";
import versionTood from "/libs/versionUpdate.js";

import userStore from "../store/user";
const router = createRouter(routerConfig);

router.beforeEach((to, from, next) => {
  //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  versionTood.isNewVersion();
  if (/mobile/i.test(navigator.userAgent)) {
    // console.log('手机')
    localStorage.setItem("isApp", true);
  } else {
    localStorage.setItem("isApp", false);
  }
  if (!JSON.parse(localStorage.getItem("columnSelecteds"))) {
    localStorage.setItem(
      "columnSelecteds",
      JSON.stringify([
        "mixRate",
        "clothKind",
        "gramWeight",
        "process",
        "bathRatio",
        "basefabric",
        "rate",
      ])
    );
  }
  // if (
  //   !globalStore.menusShow(to.fullPath) &&
  //   !globalStore.routerwhiteList.value.includes(to.fullPath)
  // ) {
  //   next({
  //     path: "/403",
  //     query: to.query,
  //   });
  //   return;
  // }
  let canLogin = JSON.parse(localStorage.getItem("canLogin")); //前端校验是不是没有权限
  let isApp = JSON.parse(localStorage.getItem("isApp")); //是否为app
  if (to.path == "/home" && isApp) {
    next({
      path: "/app-pdf",
      query: to.query,
    });
  }
  if (to.path == "/app-pdf") {
    console.log(Cookie.get("accessTokenMa"));
    if (Cookie.get("accessTokenMa")) {
      next();
      return;
    } else {
      next({
        path: isApp ? "/appLogin" : "/login",
        query: to.query,
      });
      return;
    }
  } else {
    if (!to.meta.skip_auth) {
      if (!Cookie.get("accessTokenMa")) {
        next({
          path: isApp ? "/appLogin" : "/login",
          query: {
            redirect: to.fullPath,
          },
        });
        return;
      } else if (!canLogin) {
        next({
          path: isApp ? "/appLogin" : "/login",
          query: {
            redirect: to.fullPath,
          },
        });
        return;
      }
    } else {
      if (Cookie.get("accessTokenMa") && canLogin) {
        next({
          path: isApp ? "/app-pdf" : "/",
        });
      }
    }
  }
  next();
});
router.afterEach((toRoute, fromRoute) => {
  // 混纺快速修色
  if (
    fromRoute.path === "/blend-color-trim/fast-form" &&
    toRoute.path !== "/blend-color-trim/fast-form/blend-color-form-result"
  ) {
    blendcolorFasTrimStore.init();
  }
  if (
    fromRoute.path === "/blend-color-trim/fast-form/blend-color-form-result" &&
    toRoute.path !== "/blend-color-trim/fast-form"
  ) {
    blendcolorFasTrimStore.init();
  }
  // 单纤快速修色
  if (
    fromRoute.path === "/color-trim-fast-form" &&
    toRoute.path !== "/color-trim-result"
  ) {
    colorFasTrimStore.init();
  }
  if (
    fromRoute.path === "/color-trim-result" &&
    toRoute.path !== "/color-trim-fast-form"
  ) {
    colorFasTrimStore.init();
  }

  // 单纤维 微调
  if (
    toRoute.path !== "/oneAdjustment" &&
    toRoute.path !== "/oneAdjustmentRes" &&
    toRoute.path !== "/oneAdjustment-color-trim-result"
  ) {
    adjustment.init();
    sessionStorage.removeItem("adjustmentData");
    sessionStorage.removeItem("colorTableList");
  }
  // 单纤维 自动微调
  if (
    toRoute.path !== "/sAdjustment" &&
    toRoute.path !== "/sAdjustmentRes" &&
    toRoute.path !== "/sAdjustment-color-trim-result"
  ) {
    sAdjustment.init();
    sessionStorage.removeItem("sAdjustmentData");
    // sessionStorage.removeItem("colorTableList");
  }

  // 单纤维 深色微调
  if (
    toRoute.path !== "/dAdjustment" &&
    toRoute.path !== "/dAdjustmentRes"
    // toRoute.path !== "/dAdjustment-color-trim-result"
  ) {
    // console.log("1111");
    dAdjustment.init();
    sessionStorage.removeItem("dAdjustmentData");
    sessionStorage.removeItem("dcolorTableList");
  }

  // 单纤配色 微调
  // 6/16 单纤维修色结果页 返回上一级
  if (
    (fromRoute.path === "/color-trim-adjustment" ||
      fromRoute.path === "/color-trim-form-result") &&
    toRoute.path !== "/color-trim-form"
  ) {
    // console.log("1:1");
    colorFormTrimStore.init();
    sessionStorage.removeItem("colorTableListoneTrim");
  }

  if (
    fromRoute.path === "/color-trim-form" &&
    toRoute.path !== "/color-trim-adjustment" &&
    toRoute.path !== "/color-trim-form-result"
  ) {
    // console.log("1:1");
    colorFormTrimStore.init();
    sessionStorage.removeItem("colorTableListoneTrim");
  }

  // 混纺微调 修色
  // 6/16 混纺维修色结果页 返回上一级
  if (
    fromRoute.path === "/blend-color-trim/blend-color-trim-form" &&
    toRoute.path !== "/blend-color-trim-form-adjustment-result" &&
    toRoute.path !== "/blend-color-trim-form-result"
  ) {
    console.log("1:1");
    blendcolorFormTrimStore.init();
    sessionStorage.removeItem("colorTableListTrim");
  }
  if (
    (fromRoute.path === "/blend-color-trim-form-adjustment-result" ||
      fromRoute.path === "/blend-color-trim-form-result") &&
    toRoute.path !== "/blend-color-trim/blend-color-trim-form"
  ) {
    console.log("1:1");
    blendcolorFormTrimStore.init();
    sessionStorage.removeItem("colorTableListTrim");
  }

  // 单纤修色
  // if (
  //   fromRoute.path === "/color-trim-form-result" &&
  //   toRoute.path !== "/color-trim-form"
  // ) {
  //   // colorFormTrimStore.init();
  // }

  // 小样订单修色
  if (
    fromRoute.path === "/smallSample-color-trim-form-result" &&
    toRoute.path !== "/smallSample-color-trim-form"
  ) {
    console.log("1:1");
    colorFormTrimStore.init();
  }
  // 小样订单混纺修色

  // 小样订单 微调
  if (
    fromRoute.path === "/smallSample-color-trim-adjustment" &&
    toRoute.path !== "/smallSample-color-trim-form"
  ) {
    console.log("1:1");
    colorFormTrimStore.init();
    sessionStorage.removeItem("colorTableListoneTrim");
  }
  if (
    fromRoute.path === "/smallSample-color-trim-form" &&
    toRoute.path !== "/smallSample-color-trim-adjustment"
  ) {
    console.log("1:1");
    colorFormTrimStore.init();
    sessionStorage.removeItem("colorTableListoneTrim");
  }

  if (
    toRoute.path !== "/color-match" &&
    toRoute.path !== "/color-match-table"
  ) {
    colorMatch.delParams();
    localStorage.removeItem("colorMatch");
    console.log("缓存被清了");
  }
  // 小样订单配色
  if (
    toRoute.path !== "/smallSampleColorMatch" &&
    toRoute.path !== "/smallSampleColorTable"
  ) {
    smallSampleColorMatch.delParams();
    localStorage.removeItem("smallSampleColorMatch");
  }

  // 复样订单配色
  if (
    toRoute.path !== "/DuplicateSampleColorMatch" &&
    toRoute.path !== "/DuplicateSampleColorTable"
  ) {
    DsmallSampleColorMatch.delParams();
    localStorage.removeItem("DsmallSampleColorMatch");
  }

  // 复样订单混纺配色
  if (
    toRoute.path !== "/DuplicateSampleBlendColorMatch" &&
    toRoute.path !== "/DuplicateSampleBlendColorTable"
  ) {
    // DsmallSampleColorMatch.delParams();
    sessionStorage.removeItem("DsmallSampleBlendColorMatch");
  }

  // 小样订单混纺配色
  if (
    toRoute.path !== "/smallSampleBlendColorMatch" &&
    toRoute.path !== "/smallSampleBlendColorTable"
  ) {
    // smallSampleColorMatch.delParams();
    sessionStorage.removeItem("smallSampleBlendColorMatch");
  }

  // if (
  //   toRoute.path !== "/export-filamentStarFingBath" &&
  //   toRoute.path !== "/export-filamentStarFingBathTable"
  // ) {
  //   filamentBath.delParams();
  //   localStorage.removeItem("filamentBath");
  // }
  if (
    toRoute.path !== "/quality-control" &&
    toRoute.path !== "/quality-control-result"
  ) {
    sessionStorage.removeItem("qualityControl");
  }
  if (
    toRoute.path !== "/blending-color-match" &&
    toRoute.path !== "/blending-color-match-table"
  ) {
    sessionStorage.removeItem("blendingColorMatch");
  }
  if (
    toRoute.path !== "/export-blandFilamentStarFingBath" &&
    toRoute.path !== "/export-blandFilamentStarFingBathTable"
  ) {
    sessionStorage.removeItem("blendBath");
  }
  if (
    toRoute.path !== "/export-FilamentStarFingBathRepeated" &&
    toRoute.path !== "/export-FilamentStarFingBathRepeatedTable"
  ) {
    localStorage.removeItem("FilamentStarFingBathRepeatedTable");
  }
  if (
    toRoute.path !== "/export-blandFilamentStarFingBathRepeated" &&
    toRoute.path !== "/export-blandFilamentStarFingBathRepeatedTable"
  ) {
    sessionStorage.removeItem("blendBathRepeated");
  }
  window.scrollTo(0, 0);
  globalStore.resetMainStyle();
});
// router.beforeRouteLeave((to, from, next) => {
//   console.log('hxy', to, from, next);
// });

export default router;
